import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Highlight from 'LegacyWeployDesignLanguage/Highlight';

import DateRange from '../../common/DateRange';
import List from './List';

const RoleSummaryWrapper = styled.div`
  order: 0;
`;

const RoleTitle = styled.h6`
  color: ${props => props.theme.colors.text.primary};
  margin-bottom: 0.25em;
  margin-top: 0;
`;

const RoleSummary = (props) => {
  const {
    organisation,
    industry,
    title,
    startDate,
    endDate,
    tasks,
    achievements,
    searchTerms,
  } = props;

  const { name: industryName } = industry;

  return (
    <RoleSummaryWrapper>
      <RoleTitle key={`${title}-${organisation}`}>
        <Highlight
          searchTerms={searchTerms}
          text={title}
        />
      </RoleTitle>

      {organisation && <div>{organisation}</div>}
      {industryName && <div>{industryName}</div>}

      <DateRange
        startDate={startDate}
        endDate={endDate}
      />

      <List
        title="Tasks"
        items={tasks}
        searchTerms={searchTerms}
        maxVisible={5}
      />
      <List
        title="Achievements"
        items={achievements}
        searchTerms={searchTerms}
        maxVisible={5}
      />
    </RoleSummaryWrapper>
  );
};

RoleSummary.propTypes = {
  organisation: PropTypes.string,
  industry: PropTypes.string,
  title: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  tasks: PropTypes.arrayOf(PropTypes.string),
  achievements: PropTypes.arrayOf(PropTypes.string),
  searchTerms: PropTypes.arrayOf(PropTypes.string),
};

RoleSummary.defaultProps = {
  organisation: '',
  industry: '',
  endDate: null,
  tasks: [],
  achievements: [],
  searchTerms: [],
};

export default RoleSummary;
